import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Paper,
  IconButton,
  Button,
  Divider,
  TextField,
  Chip,
  MenuItem,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import Sidebar from '../components/Sidebar.tsx';
import { useAuth } from '../context/AuthContext.tsx';

const API_BASE = process.env.REACT_APP_API_URL + '/api';


const UurRooster: React.FC = () => {
  const { isAuthenticated, user } = useAuth();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [rondes, setRondes] = useState<any[]>([]);
    const [shifts, setShifts] = useState<{
      [tourId: number]: Array<{
        day_number: number;
        user_short: string;
        user_id: number;
        type?: string | null;
        care_type?: string | null;
        functie?: string | null;   
      }>
    }>({});



  const [filterZoekTerm, setFilterZoekTerm] = useState('');
  const [actieveRondes, setActieveRondes] = useState<number[]>([]);

  const now = new Date();
  const [selectedMonth, setSelectedMonth] = useState(now.getMonth() + 1);
  const [selectedYear, setSelectedYear] = useState(now.getFullYear());
  const [publicationStatus, setPublicationStatus] = useState<{ published: boolean; updatedAt: string | null } | null>(null);
  const [publicationLoading, setPublicationLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
const [selectedTour, setSelectedTour] = useState<number | null>(null);
const [selectedDay, setSelectedDay] = useState<number | null>(null);
const [selectedType, setSelectedType] = useState<string | null>(null);

//const [available, setAvailable] = useState<any[]>([]);
//const [availableForTour, setAvailableForTour] = useState<any[]>([]);
//const [allTourNurses, setAllTourNurses] = useState<any[]>([]);
const [verpleegkundigen, setVerpleegkundigen] = useState<any[]>([]);
const [beschikbareVerpleegkundigen, setBeschikbareVerpleegkundigen] = useState<any[]>([]);
const [beschikbareVoorRonde, setBeschikbareVoorRonde] = useState<any[]>([]);
const [selectedAvailable, setSelectedAvailable] = useState<number | ''>('');
  const [selectedAvailableForTour, setSelectedAvailableForTour] = useState<number | ''>('');
  const [selectedAll, setSelectedAll] = useState<number | ''>('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const isAdmin = user?.role === 'admin';
const currentAssignment =
  selectedTour && selectedDay
    ? shifts[selectedTour]?.find(s => s.day_number === selectedDay)
    : null;




const getNurseLabel = (nurse: any) =>
  nurse?.first_name && nurse?.last_name
    ? `${nurse.first_name} ${nurse.last_name}`
    : nurse?.short || '';

const getSelectedNurse = (id: number | '', ...lists: any[]) => {
  if (!id) return null;
  for (const list of lists) {
    const found = list.find((nurse: any) => nurse.id === id);
    if (found) return found;
  }
  return null;
};


const ensureCurrentNurseInList = (
  list: any[],
  currentAssignment?: { user_id: number; user_short: string }
) => {
  if (!currentAssignment) return list;

  const alreadyPresent = list.some((nurse: any) => nurse.id === currentAssignment.user_id);
  if (alreadyPresent) return list;

  const nurseFromAll = verpleegkundigen.find(
    (nurse: any) => nurse.id === currentAssignment.user_id
  );

  if (nurseFromAll) {
    return [...list, nurseFromAll];
  }

  return [
    ...list,
    {
      id: currentAssignment.user_id,
      short: currentAssignment.user_short
    }
  ];
};

const filterNursesNotScheduledElsewhere = (
  list: any[],
  day: number,
  tourId: number,
  shiftType: string,
  currentAssignment?: { user_id: number; user_short: string }
) => {
  const bookedIds = Object.entries(shifts).flatMap(([tid, arr]) => {
    if (Number(tid) === tourId) return [];
    return arr
      .filter((shift: any) =>
        shift.day_number === day &&
        shift.type === shiftType
      )
      .map((shift: any) => shift.user_id);
  });

  const filtered = list.filter((nurse: any) => !bookedIds.includes(nurse.id));
  return ensureCurrentNurseInList(filtered, currentAssignment);
};

const openAssignmentModal = async (tourId: number, day: number, type: string) => {
  setSelectedTour(tourId);
  setSelectedDay(day);
  setSelectedType(type);

  const currentAssignment = shifts[tourId]?.find((s: any) => s.day_number === day);
  console.log('Current assignment:', currentAssignment);

  const preselectNurse = currentAssignment?.user_id ?? '';
  setSelectedAvailable(preselectNurse);
  setSelectedAvailableForTour(preselectNurse);
  setSelectedAll(preselectNurse);

  const token = localStorage.getItem('auth_token');

  try {
    // Alle beschikbare verpleegkundigen
    const response = await fetch(
      `${API_BASE}/available-nurses/${selectedYear}/${selectedMonth}/${day}/${type}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (response.ok) {
      const availableNurses = await response.json();
      setBeschikbareVerpleegkundigen(
        filterNursesNotScheduledElsewhere(
          availableNurses,
          day,
          tourId,
          type,
          currentAssignment
        )
      );
    } else {
      setBeschikbareVerpleegkundigen(
        filterNursesNotScheduledElsewhere([], day, tourId, type, currentAssignment)
      );
    }

    // Beschikbaar voor deze ronde
    const tourResponse = await fetch(
      `${API_BASE}/available-nurses-for-tour/${tourId}/${selectedYear}/${selectedMonth}/${day}/${type}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (tourResponse.ok) {
      const availableForTour = await tourResponse.json();
      setBeschikbareVoorRonde(
        ensureCurrentNurseInList(availableForTour, currentAssignment)
      );
    } else {
      setBeschikbareVoorRonde(
        ensureCurrentNurseInList([], currentAssignment)
      );
    }

  } catch (error) {
    console.error('Error fetching available nurses:', error);
    setBeschikbareVerpleegkundigen(
      ensureCurrentNurseInList([], currentAssignment)
    );
    setBeschikbareVoorRonde(
      ensureCurrentNurseInList([], currentAssignment)
    );
  }

  setModalOpen(true);
};


const closeModal = () => {
  setModalOpen(false);
  setIsSubmitting(false);
  setSelectedTour(null);
  setSelectedDay(null);
  setSelectedType(null);
  setSelectedAvailable('');
  setSelectedAvailableForTour('');
  setSelectedAll('');
};

const fetchPublicationStatus = async () => {
  const token = localStorage.getItem('auth_token');
  if (!token) return;

  setPublicationLoading(true);
  try {
    const response = await fetch(
      `${API_BASE}/roster-publication/${selectedYear}/${selectedMonth}`,
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (!response.ok) {
      throw new Error('Status ophalen mislukt');
    }

    const data = await response.json();
    setPublicationStatus({
      published: !!data.published,
      updatedAt: data.updatedAt || null
    });
  } catch (err) {
    console.error('Publicatie status fout:', err);
    setPublicationStatus(null);
  } finally {
    setPublicationLoading(false);
  }
};

const handlePublicationAction = async (action: 'publish' | 'update') => {
  const token = localStorage.getItem('auth_token');
  if (!token) return;

  setPublicationLoading(true);
  try {
    const response = await fetch(
      `${API_BASE}/roster/${selectedYear}/${selectedMonth}/${action}`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      }
    );

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      console.error('Publicatie mislukt:', err);
      return;
    }

    await fetchPublicationStatus();
  } catch (err) {
    console.error('Publicatie fout:', err);
  } finally {
    setPublicationLoading(false);
  }
};

const handleSaveAssignment = async () => {
  if (!selectedTour || !selectedDay || !selectedType || isSubmitting) return;

  const nurse =
    selectedAvailable ||
    selectedAvailableForTour ||
    selectedAll;

  if (!nurse) {
    console.warn("Geen verpleegkundige geselecteerd.");
    return;
  }

  const token = localStorage.getItem('auth_token');
  const date = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(selectedDay).padStart(2, '0')}`;

  try {
    setIsSubmitting(true);

    const response = await fetch(`${API_BASE}/assignments`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        tour_id: selectedTour,
        user_id: nurse,
        date,
        type: selectedType   // <-- SHIFT TYPE MEEGEVEN!
      })
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Opslaan mislukt:", data);
      return;
    }

    // Live UI update
    setShifts(prev => {
      const updated = { ...prev };
      updated[selectedTour] = updated[selectedTour]?.filter(s => s.day_number !== selectedDay) || [];
      updated[selectedTour].push({
        day_number: selectedDay,
        user_short: verpleegkundigen.find(v => v.id === nurse)?.short || "",
        user_id: nurse,
        type: selectedType,
        functie: verpleegkundigen.find(v => v.id === nurse)?.functie || null
      });
      return updated;
    });

    closeModal();
  } catch (err) {
    console.error("Fout bij opslaan:", err);
  } finally {
    setIsSubmitting(false);
  }
};



const handleDeleteAssignment = async () => {
  if (!selectedTour || !selectedDay || !selectedType) return;

  const token = localStorage.getItem("auth_token");
  const date = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(selectedDay).padStart(2, '0')}`;

  try {
    const response = await fetch(`${API_BASE}/assignments`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ tour_id: selectedTour, date, type: selectedType })
    });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      console.error("Verwijderen mislukt:", err);
      return;
    }

    setShifts(prev => {
      const updated = { ...prev };
      updated[selectedTour] = (updated[selectedTour] || []).filter(s => {
        if (s.day_number !== selectedDay) return true;
        const shiftType = s.type ?? selectedType;
        return shiftType !== selectedType;
      });
      return updated;
    });

    closeModal();
  } catch (err) {
    console.error("Fout bij verwijderen:", err);
  }
};

  useEffect(() => {
  const token = localStorage.getItem('auth_token');

fetch(`${API_BASE}/rooster/${selectedYear}/${selectedMonth}`, {
      headers: { Authorization: `Bearer ${token}` }
  })
    .then(res => res.json())
    .then(data => {
  console.log("Rooster data:", data);

  // Unieke rondes gebruiken
  const uniqueTours = Array.from(new Map(
    data.map((item: any) => [item.tour_id, item])
  ).values());

  setRondes(uniqueTours);
  setActieveRondes(uniqueTours.map((r: any) => r.tour_id));

  // Shifts structureren per ronde
  const shiftsByTour: Record<number, Array<{
    day_number: number;
    user_short: string;
    user_id: number;
    type?: string | null;
    care_type?: string | null;
    functie?: string | null;     // ⭐ BELANGRIJK
  }>> = {};


  data.forEach((item: any) => {
    if (!shiftsByTour[item.tour_id]) {
      shiftsByTour[item.tour_id] = [];
    }
    shiftsByTour[item.tour_id].push({
      day_number: item.day_number,
      user_short: item.user_short,
      user_id: item.user_id,
      type: item.type || null,
      care_type: item.care_type || null,
      functie: item.functie || null
    });
  });

  setShifts(shiftsByTour as any);
})
  .catch(err => console.error("Rondes fetch error:", err));
}, [selectedYear, selectedMonth]);

  useEffect(() => {
    if (!isAuthenticated) return;
    fetchPublicationStatus();
  }, [isAuthenticated, selectedYear, selectedMonth]);

  // Verpleegkundigen ophalen voor dropdown
  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    fetch(`${API_BASE}/nurses`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => setVerpleegkundigen(data))
      .catch(err => console.error('Nurses fetch error:', err));
  }, []);

const toggleRonde = (id: number) => {
  setActieveRondes(prev =>
    prev.includes(id)
      ? prev.filter(rid => rid !== id)
      : [...prev, id]
  );
};




  const toggleAlles = () => {
    setActieveRondes(prev =>
      prev.length === rondes.length ? [] : rondes.map(r => r.tour_id)
    );
  };

  if (!isAuthenticated) return null;

  const uniekeRondes = Array.from(
    new Map(rondes.map((r: any) => [r.tour_id, r])).values()
  );

  const gefilterdeRondes = uniekeRondes.filter(r =>
    r.tour_name.toLowerCase().includes(filterZoekTerm.toLowerCase())
  );

  const selectedAvailableValue = getSelectedNurse(
    selectedAvailable,
    beschikbareVerpleegkundigen,
    verpleegkundigen
  );

  const selectedAvailableForTourValue = getSelectedNurse(
    selectedAvailableForTour,
    beschikbareVoorRonde,
    verpleegkundigen
  );

  const selectedAllValue = getSelectedNurse(
    selectedAll,
    verpleegkundigen
  );
  const isPublished = publicationStatus?.published === true;


  return (
    <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' } }}>
      <Sidebar open={true} onClose={() => {}} />

      <Box component="main"
        sx={{
          flexGrow: 1,
          ml: { xs: 0, md: '70px' },
          mt: { xs: '60px', md: 0 },
          p: { xs: 1, sm: 2, md: 3 }
        }}
      >
        <Container maxWidth="xl">

          {/* Header */}
          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Typography
              variant={isMobile ? 'h6' : 'h5'}
              sx={{ color: '#4aa8b4', fontWeight: 'bold', textTransform: 'capitalize' }}
            >
              {new Date(selectedYear, selectedMonth - 1).toLocaleString("nl-BE", {
                month: "long",
                year: "numeric"
              })}
            </Typography>

            {/* Jaar terug */}
            <IconButton
              onClick={() => {
                setSelectedMonth((prev: number) => {
                  if (prev === 1) {
                    setSelectedYear((y: number) => y - 1);
                    return 12;
                  }
                  return prev - 1;
                });
              }}
              sx={{ color: '#4aa8b4' }}
            >
              ◀
            </IconButton>

            {/* Maand dropdown */}
            <TextField
              select
              size="small"
              value={selectedYear}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSelectedYear(Number(e.target.value))
              }
              sx={{ backgroundColor: 'white', width: 120 }}
            >
              {Array.from({ length: 7 }, (_, i) => {
                const year = new Date().getFullYear() - 3 + i;
                return (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                );
              })}
            </TextField>

            {/* Jaar vooruit */}
            <IconButton
              onClick={() => {
                setSelectedMonth((prev: number) => {
                  if (prev === 12) {
                    setSelectedYear((y: number) => y + 1);
                    return 1;
                  }
                  return prev + 1;
                });
              }}
              sx={{ color: '#4aa8b4' }}
            >
              ▶
            </IconButton>
          </Box>

            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {isAdmin && (
                <Button
                  variant="contained"
                  disabled={publicationLoading || publicationStatus === null}
                  onClick={() => handlePublicationAction(isPublished ? 'update' : 'publish')}
                  sx={{
                    backgroundColor: isPublished ? '#1976d2' : '#2e7d32',
                    '&:hover': {
                      backgroundColor: isPublished ? '#115293' : '#1b5e20'
                    }
                  }}
                >
                  {isPublished ? 'Updaten' : 'Publiceren'}
                </Button>
              )}

              {/* Overzicht knop */}
              <Button
                variant="contained"
                onClick={() =>
                  navigate(`/overzicht-verpleegkundigen/${selectedYear}/${selectedMonth}`)
                }
                sx={{
                  backgroundColor: '#4aa8b4',
                  '&:hover': { backgroundColor: '#3e8892' }
                }}
              >
                Individ. vpk overzicht
              </Button>
            </Box>
          </Box>

          {/* Ronde selectie + zoek */}
          <Paper sx={{ p: 2, mb: 3 }}>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Selecteer een ronde
            </Typography>

            <Button
              variant="outlined"
              size="small"
              onClick={toggleAlles}
              sx={{
                mb: 2,
                borderColor: '#4aa8b4',
                color: '#4aa8b4',
                '&:hover': {
                  backgroundColor: '#e0f2f5',
                  borderColor: '#3e8892'
                }
              }}
            >
              {actieveRondes.length === rondes.length ? 'Alles verbergen' : 'Alles tonen'}
            </Button>

            <Divider sx={{ mb: 2 }} />

            <TextField
              size="small"
              placeholder="Zoek ronde..."
              value={filterZoekTerm}
              onChange={(e) => setFilterZoekTerm(e.target.value)}
              fullWidth
              sx={{ mb: 2 }}
            />

            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {gefilterdeRondes.map((ronde: any) => (
                <Chip
                  key={ronde.tour_id}
                  label={ronde.tour_name}
                  onClick={() => toggleRonde(ronde.tour_id)}
                  sx={{
                    backgroundColor: actieveRondes.includes(ronde.tour_id)
                      ? '#4aa8b4'
                      : '#d0d0d0',
                    color: actieveRondes.includes(ronde.tour_id)
                      ? 'white'
                      : 'black',
                    cursor: 'pointer'
                  }}
                />
              ))}
            </Box>
          </Paper>

          {/* Rooster / planning */}
          <Box sx={{
            maxHeight: '72vh',
            overflowY: 'auto',
            border: '1px solid #e0e0e0',
            borderRadius: 1,
            p: 1
          }}>
            {uniekeRondes
            .filter(r => actieveRondes.includes(r.tour_id))
            .filter(r => r.tour_name.toLowerCase().includes(filterZoekTerm.toLowerCase()))
            .map((ronde) => (
                <Paper key={ronde.tour_id} sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      backgroundColor:
                        ronde.care_type === 'zorgkundige'
                          ? '#ff8800'   // zorgkundige = oranje
                          : '#4aa8b4',  // vpk of leeg = blauw
                      color: 'white',
                      p: 1.5,
                      fontSize: '1.1rem',
                      fontWeight: 'bold'
                    }}
                  >
                    {ronde.tour_name} {ronde.tour_type === 'late' ? '(Late)' : ''}
                  </Box>
                  <Box sx={{ p: 1 }}>
                    <Box sx={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 1fr))',
                      gap: 1
                    }}>
                      {Array.from({ length: new Date(selectedYear, selectedMonth, 0).getDate() }, (_, d) => {
                        const dag = d + 1;
                        const dienst = shifts[ronde.tour_id]?.find((s: any) => s.day_number === dag);

                        const dateObj = new Date(selectedYear, selectedMonth - 1, dag);
                        const isWeekend = dateObj.getDay() === 0 || dateObj.getDay() === 6;

                        return (
                          <Box 
                            key={dag} 
                            sx={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              p: 0.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 1,
                              minHeight: '60px',
                              backgroundColor: isWeekend
                                ? '#bfbfbfff' // ⭐ weekend = licht grijs
                                : dienst
                                  ? (dienst.functie === 'Zorgkundige'
                                      ? 'rgba(255, 136, 0, 0.25)'
                                      : dienst.functie === 'Verpleegkundige'
                                        ? 'rgba(74, 168, 180, 0.25)'
                                        : '#fafafa'
                                    )
                                  : '#fafafa',
                              cursor: 'pointer',
                              '&:hover': {
                                backgroundColor: '#e0f2f5',
                                borderColor: '#4aa8b4'
                              }
                            }}
                            onClick={() => openAssignmentModal(ronde.tour_id, dag, ronde.tour_type)}
                          >
                            <Typography variant="caption"
                              sx={{ fontWeight: 'bold', mb: .5, color: '#4aa8b4' }}>
                              {String(dag).padStart(2, '0')}
                            </Typography>

                            {dienst ? (
                              <Typography 
                                sx={{ 
                                  fontSize: '0.7rem', 
                                  fontWeight: 'bold', 
                                  color: '#333'
                                }}
                              >
                              {dienst.user_short}
                              </Typography>
                            ) : (
                              <IconButton
                                size="small"
                                sx={{
                                  width: 30,
                                  height: 30,
                                  backgroundColor: '#4aa8b4',
                                  color: 'white',
                                  '&:hover': { backgroundColor: '#398a94' }
                                }}
                              >
                                <AddIcon sx={{ fontSize: '1.1rem' }} />
                              </IconButton>
                            )}
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Paper>
              ))}
          </Box>
        </Container>
      </Box>

      {/* Assignment Modal */}
      <Dialog open={modalOpen} onClose={closeModal} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ backgroundColor: '#4aa8b4', color: 'white', textAlign: 'center' }}>
          {selectedDay && selectedMonth && selectedYear && (
            `${new Date(selectedYear, selectedMonth - 1, selectedDay).toLocaleDateString('nl-BE', { weekday: 'short' })}. ${String(selectedDay).padStart(2, '0')} ${
              new Date(selectedYear, selectedMonth - 1).toLocaleDateString('nl-BE', { month: 'short' }).toLowerCase()
            }. ${selectedYear} / ${rondes.find(r => r.tour_id === selectedTour)?.tour_name || ''} / ${selectedType === 'late' ? 'late' : 'vroege'}`
          )}
        </DialogTitle>
        
        <DialogContent sx={{ p: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
            
            {/* Beschikbare verpleegkundigen */}
            <Autocomplete
              fullWidth
              options={beschikbareVerpleegkundigen}
              getOptionLabel={(option) => getNurseLabel(option)}
              value={selectedAvailableValue}
              onChange={(_, newValue) => {
                setSelectedAvailable(newValue?.id ?? '');
                setSelectedAvailableForTour('');
                setSelectedAll('');
              }}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Beschikbare verpleegkundigen"
                  placeholder="Zoek en kies een verpleegkundige"
                />
              )}
            />

            {/* Beschik. verpl. voor deze ronde */}
            <Autocomplete
              fullWidth
              options={beschikbareVoorRonde}
              getOptionLabel={(option) => getNurseLabel(option)}
              value={selectedAvailableForTourValue}
              onChange={(_, newValue) => {
                setSelectedAvailableForTour(newValue?.id ?? '');
                setSelectedAvailable('');
                setSelectedAll('');
              }}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Beschik. verpl. voor deze ronde"
                  placeholder="Zoek en kies een verpleegkundige"
                />
              )}
            />

            {/* Alle verpleegkundigen */}
            <Autocomplete
              fullWidth
              options={verpleegkundigen}
              getOptionLabel={(option) => getNurseLabel(option)}
              value={selectedAllValue}
              onChange={(_, newValue) => {
                setSelectedAll(newValue?.id ?? '');
                setSelectedAvailable('');
                setSelectedAvailableForTour('');
              }}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Alle verpleegkundigen"
                  placeholder="Zoek en kies een verpleegkundige"
                />
              )}
            />
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, justifyContent: 'space-between' }}>
          <IconButton 
            onClick={handleDeleteAssignment}
            sx={{ color: '#f44336' }}
            disabled={!currentAssignment || !selectedType || isSubmitting}
          >
            <DeleteIcon />
          </IconButton>
          
          <Button 
            variant="contained" 
            onClick={handleSaveAssignment}
            disabled={isSubmitting}
            sx={{ 
              backgroundColor: isSubmitting ? '#c3c3c3' : '#4aa8b4',
              '&:hover': { backgroundColor: isSubmitting ? '#c3c3c3' : '#3e8892' }
            }}
          >
            {isSubmitting ? 'Opslaan...' : 'Opslaan'}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    
  );
};

export default UurRooster;
